import React from 'react';
import './MenuInterior.css';
import { Link } from 'react-router-dom';

export default class MenuInterior extends React.Component{
    render(){
        return(
            <div className="padding-top has-text-left">
                <p className="menu-label">
                    Usuario
                </p>
                {/* <ul className="menu-list">
                    <li><a><i className="fa fa-edit"></i>Editar datos</a></li>
                    <li><a><i className="fa fa-lock"></i>Cambiar contraseña</a></li>
                </ul> */}
                <p className="menu-label">
                    Administración
                </p>
                <ul className="menu-list">
                    <li><Link to={'/Juegos'}><i className="fa fa-futbol"></i>Juegos</Link></li>
                    <li><Link to={'/Torneos'}><i className="fa fa-futbol"></i>Torneos</Link></li>
                    <li><Link to={'/Ligas'}><i className="fa fa-trophy"></i>Ligas</Link></li>
                    <li><Link to={'/Equipos'}><i className="fas fa-shield-alt"></i>Equipos</Link></li>
                    <li><Link to={'/Jugadores'}><i className="fa fa-id-card"></i>Jugadores</Link></li>
                    <li><Link to={'/Sancionados'}><i className="fas fa-user-alt-slash"></i>Sancionados</Link></li>
                </ul>
                <p className="menu-label">
                    Catálogos
                </p>
                <ul className="menu-list">
                    <li><Link to={'/Canchas'}><i className="fab fa-courts"></i>Canchas</Link></li>
                    <li><Link to={'/Arbitros'}><i className="fa fa-whistle"></i>Árbitros</Link></li>
                    <li><Link to={'/Capitanes'}><i className="fa fa-id-card"></i>Capitanes</Link></li>
                </ul>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/menuInterior/MenuInterior.js